<template>
  <div id="form">
    <div id="headerText" v-if="!viewAlert && !viewProgress">
      <p id="firstMessage">Verificación de Referencia Familiar</p>
      <p id="secondMessage">
        ¡Hola {{AssignmentProp.family_reference_full_name}}! Aquí podrás contarnos sobre tu relación personal con {{candidate_name}} 
      </p>
      <p id="secondMessage">Si tienes alguna duda, puedes comunicarte con nosotros al número (+57) 320 472 59 21 o en <a href="www.globalwork.co">www.globalwork.co</a></p>
    </div>
   <div v-if="!viewAlert && !viewProgress" class="" id="divForm" style="">
    <template v-if="!done">
      <div style="margin:24px">
        <div id="contractAgain">
          <p class="myLabel" style="" for="description">De 1 a 5, ¿Cómo califica el desempeño laboral del referenciado? 1 es el puntaje mínimo y 5 es el máximo</p>
          <multiselect v-model="qualification" :options="qualityNumber" :close-on-select="true" :clear-on-select="false" label="name" placeholder="Seleccionar" selectLabel="Presione para seleccionar" selectedLabel="Seleccionada" deselectLabel="Presione para eliminar" track-by="name" required="true">    
          </multiselect>
          <span id="alertQualities" style="color: red; font-family: Montserrat;" v-if="qualificationMessage != ''"><br>{{qualificationMessage}}</span>      
        </div>
      </div>    

      <div style="margin:24px" id="qualities">
        <div >
          <p class="myLabel" style="" for="description">¿Que cualidades destacas del referenciado?</p>
          <multiselect v-model="values" :options="cualidades" :multiple="true" :close-on-select="false" :clear-on-select="false" label="name" placeholder="Seleccionar" selectLabel="Presione para seleccionar" selectedLabel="Seleccionada" deselectLabel="Presione para eliminar" track-by="name"  :preserve-search="true">    
            <template slot="selection" slot-scope="{ values, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} cualidades seleccionadas</span></template>
          </multiselect>      
        </div>
      </div>

      <div style="margin:24px" id="relationship">
        <div >
          <p class="myLabel" style="" for="description">¿Que parentesco tiene con el referenciado?</p>
          <multiselect v-model="family_reference_relationship" :options="relationship" :multiple="false" :close-on-select="true" :clear-on-select="false" label="name" placeholder="Seleccionar" selectLabel="Presione para seleccionar" selectedLabel="Seleccionada" deselectLabel="Presione para eliminar" track-by="name">    
          </multiselect>      
        </div>
      </div>

      <div style="margin:24px">
        <div >
          <p class="myLabel" style="" for="description">Por favor, indique su ciudad de residencia</p>
            <autocomplete class="" :model.sync="AssignmentProp.family_reference_city_id" :items="cities"/>
        </div>
      </div>


      <div class="" style="margin:24px">
        <div >
          <p class="myLabel" for="observations">¿Te gustaría contarnos algo más sobre el referenciado?</p>
          <p class="myLabel" for="observations">Toda la información que nos puedas compartir es de gran valor para los encargados del proceso de selección</p>
          <input type="text" v-model="AssignmentProp.family_reference_observations" class="myImput" />
        </div>
      </div>

      <div class="" style="margin:24px">
        <div >
          <button @click="saveReference" class="mybutton" id="saveReference">Guardar Información</button>
        </div>
      </div>
    </template>
    <p id="firstMessage" v-else>La información ha sido diligenciada</p>
   </div>

    <div v-if="viewAlert" id="greatingText">
      <p id="greatText">¡Muchas gracias por tu información!</p>
      <p id="explainGreat">
        Somos Globalwork. Una compañía que crea vínculos confiables en procesos <br> de selección a través de visitas domiciliarias y estudios de seguridad
      </p>
    </div>
    <div v-if="viewAlert" id="aboutUs" style="position: relative;
    top: 25vh;
    text-align: center;">
      <img id="serviceImg" src="https://www.globalwork.co/wp-content/uploads/2020/05/icon-verificacion-antecedentes-home.svg" alt="">
      <p id="firstInformativeText">
        ¿Quieres saber más acerca de nuestros Estudios de Seguridad?  
      </p>
      <a id="secodnInformativeText" href="https://www.globalwork.co/">
        Conoce más de nuestro servicio
      </a>  
    </div>

      <!--Barra de progreso-->
    <div v-if="viewProgress && !viewAlert">
      <p id="savingMessage">Guardando tu información</p>
      <div class="pro-bar-container">
        <div class="pro-bar pro-bar-width" data-pro-bar-percent="80">
          <div class="pro-bar-candy"></div>
        </div>
      </div>
    </div>

    <!-- Fin Barra de progreso-->
  </div>
</template>

<script>
const Multiselect =() => import('vue-multiselect')
import axios from 'axios'
import Autocomplete from './../../own/autocomplete-local'
import validate from './../../../mixiens/validate-forms'
export default {
  name:'FamilyReferenceConfirmation',
  props:['assignment','assignment_work','candidate_name','cities'],
  mixins:[validate],
  data(){
    return{
      values:[],
      cualidades:[
        {id:'Amabilidad y empatía',name:'Amabilidad y empatía'},
        {id:'Compromiso',name:'Compromiso'},
        {id:'Inteligencia emocional',name:'Inteligencia emocional'},
        {id:'Puntualidad y cumplimiento',name:'Puntualidad y cumplimiento'},
        {id:'Creatividad',name:'Creatividad'},
        {id:'Experticia',name:'Experticia'},
        {id:'Carisma e inteligencia social',name:'Carisma e inteligencia social'},
        {id:'Recursividad y resolución de problemas',name:'Recursividad y resolución de problemas'},
        {id:'Orientación al logro',name:'Orientación al logro'},
        {id:'Organización, planificación y productividad',name:'Organización, planificación y productividad'},
        {id:'Vocación de aprendizaje continuo',name:'Vocación de aprendizaje continuo'},
        {id:'Trabajo en equipo',name:'Trabajo en equipo'},
        {id:'Honestidad',name:'Honestidad'},
        {id:'Capacidades comunicativas',name:'Capacidades comunicativas'},
        {id:'Actitud positiva',name:'Actitud positiva'},
        {id:'Adaptabilidad al cambio',name:'Adaptabilidad al cambio'},
        {id:'Proactividad',name:'Proactividad'},
        {id:'Ética profesional',name:'Ética profesional'},
        {id:'Tolerancia a la presión y a la frustración',name:'Tolerancia a la presión y a la frustración'},
        {id:'Liderazgo y capacidad de inspirar',name:'Liderazgo y capacidad de inspirar'},
        {id:'Pensamiento crítico',name:'Pensamiento crítico'},
        {id:'Autogestión',name:'Autogestión'},
        {id:'Innovación',name:'Innovación'},
        {id:'Actitud de servicio',name:'Actitud de servicio'},
        {id:'Buen juicio y toma de decisiones',name:'Buen juicio y toma de decisiones'},
      ],
      viewAlert:false,
      qualification:null,
      contractAgain:[
        {id:'Si', name:'Si'},
        {id:'No', name:'No'}
      ],
      qualityNumber:[
        {id: 1, name: 1 },
        {id: 2, name: 2 },
        {id: 3, name: 3 },
        {id: 4, name: 4 },
        {id: 5, name: 5 }
      ], 
      qualificationMessage: '',           
      description:null,
      contract:0,
      source: '',
      family_reference_relationship: null,
      viewProgress:false,
      assignment_types: [3, 9, 10],
      done: false,      
    }
  },
  methods:{
    async saveReference(){
      let validation = this.validateForm('qualities','alertQualities',this.values,'length')
      if(validation){
        validation = this.validateForm('relationship','alertRelation',this.family_reference_relationship,'null')
      }

      if(validation && this.qualification != null){
        this.viewProgress = true
        this.AssignmentProp.answer_source = this.source
        this.AssignmentProp.family_reference_relationship = (this.family_reference_relationship.id - 1)
        this.AssignmentProp.qualification = this.qualification.id
        this.AssignmentProp.personality = ""
        this.AssignmentProp.filled_out_by_reference = true
        this.values.forEach(element => {
          this.AssignmentProp.personality += element.name + ' '
        })

        var token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
			  axios.defaults.headers['x-csrf-token'] = token
			  axios.defaults.headers.common['Accept'] = 'application/json';
        axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

        let response = await axios.put(`/family_references/${this.AssignmentProp.id}`,this.AssignmentProp)

        if(response.status == 200) {
          this.viewProgress = false
          this.viewAlert = true        
        }
      }
      if (this.qualification == null) {
        this.qualificationMessage = 'Este campo es obligatorio'
      }            
    }
  },
  computed:{
    AssignmentProp:{
      get(){
        return this.assignment
      },
      set(val){
        this.emit('update:assignment',val)
      }
    }
  },
  components:{
    'multiselect':Multiselect,
    'autocomplete':Autocomplete
  },
  created(){
    let source = window.location.search.split('source=')[1]
    if (source != null) {
      this.source = source
    }
    this.contract = this.AssignmentProp.contract
    this.qualification = this.AssignmentProp.qualification
    if (this.AssignmentProp.verified_reference) {
      this.viewAlert = true
    }
  },
  watch:{
    values(val){
      console.log(this.values)
    }
  },
  mounted(){
    if (this.assignment_work != null) {
      if (this.assignment_work.status == 4) this.done = true
    }
    document.getElementById('inputCity').className = "myImput"
  }
}
</script>

<style>

</style>
